import { useAppSelector } from '@App/hooks'
import { Order } from '@App/redux/slices/trade/trades/types'

import { EditOrder } from '../../../SpotOrderTrade/components/LimitOrderBlock/components/EditOrder'
import { CancelTradeProvider } from '../../../SpotOrderTrade/components/LimitOrderBlock/components/EditTrade/components/AmountToClose/model'
import { ORDER_ACTION_TYPE } from '../../../SpotOrderTrade/components/types'
import { ORDER_TYPE_NAME } from '../../../SpotOrderTrade/containers/types'

import s from './styles.module.scss'

export const EditOrderContainer = ({ order }: { order: Order | null }) => {
  const market = useAppSelector((state) => state.config.markets.find((m) => m.id === order?.market.id))

  return (
    order &&
    market ? (
      <div className={s.container}>
        <CancelTradeProvider order={order} key={order.id}>
          <EditOrder
            order={order}
            operationType={order.action_type as ORDER_ACTION_TYPE}
            current_market={market}
            orderType={ORDER_TYPE_NAME.LIMIT}
          />
        </CancelTradeProvider>
      </div>
    ) : <></>
  )
}
